module.exports = __webpack_public_path__ + "img/pop-logo.fd899057.svg";